'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = OnlinepbxStatus;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function OnlinepbxStatus(_ref) {
  var status = _ref.status;

  return _react2['default'].createElement(
    'div',
    { className: 'onlinepbx__lib__status' },
    status.isEllipse && _react2['default'].createElement('div', {
      title: status.text || status.title,
      className: (0, _classnames2['default'])('onlinepbx__lib__status__ellipse', _defineProperty({
        onlinepbx__lib__status__ellipse__send: status.send,
        onlinepbx__lib__status__ellipse__trying: status.trying,
        onlinepbx__lib__status__ellipse__fail: status.fail,
        onlinepbx__lib__status__ellipse__reged: status.reged,
        onlinepbx__lib__status__ellipse__empty: status.empty,
        onlinepbx__lib__status__ellipse__text: status.text || status.statusText
      }, 'onlinepbx__lib__status__ellipse__' + String(status.name), status.name))
    }),
    status.statusText && _react2['default'].createElement(
      'div',
      {
        title: status.statusText,
        className: (0, _classnames2['default'])('onlinepbx__lib__status__text', _defineProperty({
          onlinepbx__lib__status__text__trying: status.trying,
          onlinepbx__lib__status__text__fail: status.fail,
          onlinepbx__lib__status__text__reged: status.reged
        }, 'onlinepbx__lib__status__text__' + String(status.name), status.name))
      },
      status.statusText
    )
  );
}